import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const TONE_HEAD = {
  primary: 'ahri-dash-section__head--primary',
  indigo: 'ahri-dash-section__head--indigo',
  emerald: 'ahri-dash-section__head--emerald',
  amber: 'ahri-dash-section__head--amber',
  rose: 'ahri-dash-section__head--rose',
  violet: 'ahri-dash-section__head--violet',
};

function SectionPanel({
  title,
  description,
  linkTo,
  linkLabel,
  children,
  tone = 'primary',
  icon: Icon,
}) {
  const headClass = TONE_HEAD[tone] || TONE_HEAD.primary;

  return (
    <section className="ahri-dash-section">
      <div className={`ahri-dash-section__head ${headClass}`}>
        <div className="d-flex align-items-center gap-3">
          {Icon ? (
            <span className="ahri-dash-section__icon">
              <Icon size={22} strokeWidth={2} />
            </span>
          ) : null}
          <div>
            <h5 className="mb-0 fw-semibold text-dark">{title}</h5>
            {description ? <p className="mb-0 small text-muted">{description}</p> : null}
          </div>
        </div>
        {linkTo ? (
          <Link to={linkTo} className="btn btn-sm ahri-dash-section__link btn-outline-secondary d-inline-flex align-items-center gap-1">
            {linkLabel || 'Open'}
            <ArrowUpRight size={14} />
          </Link>
        ) : null}
      </div>
      <div className="ahri-dash-section__body">{children}</div>
    </section>
  );
}

export default SectionPanel;
